import { fmtEuroInt } from '../lib/format'

const ONLINE_BLUE = 'var(--accent-online)'
const TROEDEL_PURPLE = 'var(--accent-troedel)'
const EMPTY_STUB = 'color-mix(in srgb, var(--label-primary) 6%, transparent)'
const CHART_H = 104   // Balken-Fläche (Mockup)
const BAR_MAX = 92    // höchster Balken innerhalb der Fläche

const CARD = 'bg-[var(--bg-L1)] border border-[var(--border-subtle)] rounded-[22px]'

// Kopfzeile in der Kachel: "Überblick" links, "4 Wochen" rechts (Mockup zustand-1).
function ChartHead() {
  return (
    <div className="flex justify-between items-baseline mb-5">
      <span className="text-[15px] font-medium text-[var(--label-primary)]">Überblick</span>
      <span className="text-[13px] text-[var(--label-tertiary)]">4 Wochen</span>
    </div>
  )
}

export function OverviewChart({ data }) {
  const total = data.reduce((s, w) => s + w.online_cents + w.troedel_cents, 0)

  if (!data.length || total === 0) {
    return (
      <div className={`${CARD} px-[18px] pt-[18px] pb-5`}>
        <ChartHead />
        <div className="flex items-center justify-center h-[120px]">
          <p className="text-[15px] text-[var(--label-secondary)]">Noch keine Umsätze</p>
        </div>
      </div>
    )
  }

  const max = Math.max(...data.map(w => w.online_cents + w.troedel_cents))

  return (
    <div className={`${CARD} px-[18px] pt-[18px] pb-5`}>
      <ChartHead />
      {/* Total + "Brutto" auf einer Zeile */}
      <div className="flex items-baseline gap-2 mb-[22px]">
        <span className="text-[26px] font-medium leading-none">{fmtEuroInt(total / 100)}</span>
        <span className="text-[13px] text-[var(--label-tertiary)]">Brutto</span>
      </div>

      {/* Balken — am Boden ausgerichtet, dick (max 50px) */}
      <div className="flex items-end justify-between gap-[14px]" style={{ height: CHART_H }}>
        {data.map((w, i) => {
          const totalBar = w.online_cents + w.troedel_cents
          const isEmpty = totalBar === 0
          const oh = max > 0 ? Math.round((w.online_cents / max) * BAR_MAX) : 0
          const th = max > 0 ? Math.round((w.troedel_cents / max) * BAR_MAX) : 0
          return (
            <div key={w.label} className="flex-1 flex items-end justify-center h-full min-w-0">
              {isEmpty ? (
                <div className="w-full max-w-[50px]" style={{ height: 6, borderRadius: 4, background: EMPTY_STUB }} />
              ) : (
                <div className="w-full max-w-[50px] flex flex-col">
                  {th > 0 && (
                    <div style={{ background: TROEDEL_PURPLE, height: th, borderTopLeftRadius: 8, borderTopRightRadius: 8, borderBottomLeftRadius: oh > 0 ? 0 : 8, borderBottomRightRadius: oh > 0 ? 0 : 8 }} />
                  )}
                  {oh > 0 && (
                    <div style={{ background: ONLINE_BLUE, height: oh, borderBottomLeftRadius: 8, borderBottomRightRadius: 8, borderTopLeftRadius: th > 0 ? 0 : 8, borderTopRightRadius: th > 0 ? 0 : 8 }} />
                  )}
                </div>
              )}
            </div>
          )
        })}
      </div>

      {/* Werte unter den Balken */}
      <div className="flex justify-between gap-[14px] mt-[11px]">
        {data.map((w, i) => {
          const totalBar = w.online_cents + w.troedel_cents
          const isEmpty = totalBar === 0
          const isActive = i === data.length - 1
          return (
            <span
              key={w.label}
              className="flex-1 text-center text-[15px]"
              style={{
                color: isEmpty ? 'var(--label-tertiary)' : (isActive ? 'var(--label-primary)' : 'var(--label-secondary)'),
                fontWeight: isActive && !isEmpty ? 500 : 400,
              }}
            >
              {isEmpty ? '–' : fmtEuroInt(totalBar / 100)}
            </span>
          )
        })}
      </div>
    </div>
  )
}
